/**
 * Filter Status (for list operations)
 */
export const FILTER_STATUS = {
    ALL: "all",
    RUNNING: "running",
    DONE: "done",
    COMPLETED: "completed",
    ERROR: "error",
    PENDING: "pending",
} as const;
